module.exports = __webpack_public_path__ + "assets/img/hade@2x.378bc0d6.png";